<template>
  <span>
      <div class="c-equipCards__img">
          <picture>
              <source :data-srcset="equipment.main_image_href[0]" :srcset="equipment.main_image_href[0]"
                  media="(max-width: 767px)">
              <img width="270" height="270" :src="equipment.main_image_href[0]" :alt="equipment['title_' + lang]">
          </picture>
      </div>
      <div class="c-equipCards__content">
          <div class="c-equipCards__content--title">
              <div v-if="equipment['title_' + lang]" class="Editable">
                  <h6>{{ equipment['title_' + lang] }}</h6>
              </div>
          </div>
          <div v-if="equipment.modele" class="c-equipCards__content--subtitle">
              <span>{{ card_model_title }} {{equipment.modele}}</span>
          </div>

          <div v-if="equipment['subbodyparts_title_' + lang]" class="c-equipCards__content--model">
              <span>{{ equipment['subbodyparts_title_' + lang] }}</span>
          </div>
      </div>
  </span>
</template>

<script>
export default {
    name: "Card",
    props : ['equipment'],
    data() {
        return {
            // translation
            lang: window.Store.app.lang,
            // translation
            card_model_title: window.Store.translate_strings.filter ? window.Store.translate_strings.filter.card_model_title : '',
        }
    }
}
</script>

<style scoped>

</style>